import { render, staticRenderFns } from "./FreeResourceManage.vue?vue&type=template&id=7d5c1682&scoped=true"
import script from "./FreeResourceManage.vue?vue&type=script&lang=js"
export * from "./FreeResourceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5c1682",
  null
  
)

export default component.exports